export default "__VITE_ASSET__BDHNOl3m__"